import { FetchProductsResponse } from "./productsApi"
import { GroupItem, ProductItem, ProductTableRow } from "./productsTypes"

/** Transform products data with sortOrder sorting - use for SortProductsTab */
export function transformProductsDataWithSortOrder(data: FetchProductsResponse): ProductTableRow[] {
    const sortedGroups = [...data.productGroups].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))

    return sortedGroups.flatMap((group) => {
        const groupItem: GroupItem = {
            type: "group",
            id: group.id,
            name: group.name,
            productNumber: undefined,
            price: undefined,
            isActive: undefined,
            sortOrder: undefined,
            marketingDetails: undefined,
            productPhoto: undefined,
            userDetails: undefined,
            offerDetails: undefined,
            productDescription: undefined,
            priceExclVat: undefined,
            priceInclVat: undefined,
            stock: undefined,
            orderDetails: undefined,
        }

        const products = [...group.products]
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            .map<ProductItem>((product) => ({
                type: "product",
                groupId: group.id,
                ...product,
            }))

        return [groupItem, ...products]
    })
}

/** Transform products data without sortOrder sorting - use for AllProductsTab */
export function transformProductsData(data: FetchProductsResponse): ProductTableRow[] {
    return data.productGroups.flatMap((group) => {
        const groupItem: GroupItem = {
            type: "group",
            id: group.id,
            name: group.name,
            productNumber: undefined,
            price: undefined,
            isActive: undefined,
            sortOrder: undefined,
            marketingDetails: undefined,
            productPhoto: undefined,
            userDetails: undefined,
            offerDetails: undefined,
            productDescription: undefined,
            priceExclVat: undefined,
            priceInclVat: undefined,
            stock: undefined,
            orderDetails: undefined,
        }

        const products = group.products.map<ProductItem>((product) => ({
            type: "product",
            groupId: group.id,
            ...product,
        }))

        return [groupItem, ...products]
    })
}
